import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { OptionsPropType } from '../../shared/propTypes/common';
import { paramPropType } from '../../shared/customReports/propTypes';
import { CustomReportParameter } from './customReportParameter.component';


class ParamForm extends PureComponent {
  static propTypes = {
    params: PropTypes.arrayOf(paramPropType),
    queryParams: PropTypes.objectOf(PropTypes.string),
    customReportParamsOptions: PropTypes.objectOf(OptionsPropType),

    updateQueryParams: PropTypes.func.isRequired,
    isLoading: PropTypes.bool,
    archivalFlag: PropTypes.bool,
    restrictBatchDefaults: PropTypes.bool,
    userRole: PropTypes.string,
    editable: PropTypes.bool,
  };

  static defaultProps = {
    restrictBatchDefaults: false,
  };

  renderParam = param => {
    const {
      updateQueryParams,
      queryParams,
      customReportParamsOptions,
      isLoading,
      archivalFlag,
      restrictBatchDefaults,
      userRole,
      editable,
    } = this.props;

    return CustomReportParameter({
      param,
      paramsOptions: customReportParamsOptions,
      updateValue: updateQueryParams,
      isLoading,
      queryParams,
      archivalFlag,
      restrictBatchDefaults,
      userRole,
      editable,
    });
  };

  render() {
    const {
      params,
    } = this.props;

    return (
      <div className="custom-report-params-container">
        {params && params.length ? params.map(this.renderParam) : null}
      </div>
    );
  }
}

export default ParamForm;
